<template>
  <v-container class="mx-lg-6 mt-7">
    <v-row>
      <v-spacer/>
      <v-col sm="11" xl="9">
        <v-row class="my-2">
          <v-col cols="12">
            <span
                style="font-weight: bolder; font-size: larger">Geschützter Zugang mit erweitertem Produkt- und Funktionsangebot</span>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
    </v-row>
    <v-row>
      <v-spacer/>
      <v-col sm="11" xl="10">
        <v-row>
          <v-col cols="auto">
            <v-btn color="green" height="30" dark class="mt-2"
                   type="submit" target="_blank" href="/portal/?appid=vup">
              <v-icon
                  left
              >mdi-cube-outline
              </v-icon>
              <span style="font-size: larger">Portal-Anwendung öffnen</span>

            </v-btn>
            <v-btn color="dimgrey" style="width: 200px" height="30" class="mt-2 ml-4"
                   type="submit" target="_blank" href="/customer-administration/UserAdmin/Login.jsp">
              <v-icon
                  left
              >mdi-account-group
              </v-icon>
              <span style="font-size: larger">zur Nutzerverwaltung</span>
            </v-btn>
            <br><br>
            <v-row class="ml-3">
              <span class="pt-2 pl-1">Das <b>Portal-Login</b> finden Sie oben links im Menü (bzw. im Hinweistext der Antragsmaske "Klicken Sie <u><b>hier</b></u> zum Anmelden").
                <v-img class="my-2"
                  max-width="400"
                  :src="require('@/assets/login.png')"
                  alt="Ausschnitt Kartendarstellung des Liegenschaftskatasters"
              ></v-img></span>
              <span>
            Sollten Sie Ihr <b>Passwort vergessen</b> haben, wenden Sie sich bitte an Ihre zuständige <b>Kundenadministration</b>
            bzw. die <router-link style="border-left-style: none; margin-right: 15px;" target="_blank" to="/hilfe">Kundenbetreuung in Ihrer zuständigen Bezirksregierung.</router-link>
          </span>
            </v-row>
            <v-row>
              <v-col sm="11" xl="9">
                <v-row class="ml-1">
                  <v-col cols="12">
                    <a style="text-decoration: none" href="/info/VUP Benutzerhandbuch_geschützter Zugang.pdf"
                       target="_blank">> Benutzerhandbuch für registrierte Vermessungsstellen (PDF-Dokument)</a>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer/>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="#3C506E" height="30" dark to="/bestellformular/vermessungsstellen"
                   usergroupSelected="vermessungsstellen">
              <v-icon
                  left
              >mdi-human-handsup
              </v-icon>
              <span style="font-size: larger">Bestellformular ohne Kartennutzung (barrierefreier)</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-row class="mx-16 my-2 pl-0">
        <VCardMessages class="mt-2" typeOfAccess="vermessungsstellen"/>
      </v-row>
    </v-row>
    <v-row class="mb-4" justify="center">
      <v-col sm="11" xl="9">
        <v-row class="my-2">
          <InfoMap :messages="messages" typeOfAccess="vermessungsstellen" class="mb-2"/>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import axios from "axios";
import InfoMap from "@/components/InfoMap";
import VListProductInfo from "@/components/VListProductInfo";
import VCardMessages from "@/components/VCardMessages.vue";
import {endpoint} from "@/config";

export default {

  components: {
    VCardMessages,
    InfoMap,
    VListProductInfo
  },
  data() {
    return {
      hidePassword: true,
      showProductInfo: false,
      showAvailability: false,
      messages: [],
    }
  },
  methods: {
    getMessages() {
      axios.post(`${this.$config.API}${endpoint.getMessages}`).then((response) => {
        this.messages = response.data.features;
      }).catch(function () {
      })

    },
  },
  mounted() {
    this.getMessages();
  },
}
</script>
